import { ApiModel } from 'types/swagger/clarifai-api';
import { fetchApi } from 'utils/request';

export type PartialModelInfo = Pick<ApiModel, 'id' | 'user_id' | 'app_id'> & { model_version?: { id: string } };

export type FetchResourcePricingParams = {
  models: PartialModelInfo[];
};

export interface ModelPrice {
  model?: ApiModel;
  price_per_op?: number;
  price_per_prompt_token?: number;
  price_per_completion_token?: number;
}

export interface IFetchResourcePricingResponse {
  status: CF.API.Status;
  model_prices: ModelPrice[];
}

export const fetchResourcePrices = (body: FetchResourcePricingParams): Promise<IFetchResourcePricingResponse> =>
  fetchApi({
    path: `/api/_api/v2/resource_prices/searches`,
    method: 'POST',
    body,
  });
